class Tabswitching {
  constructor(el, opt) {
    this.el = el;
    if ($('.' + this.el).length > 0) {
      this.event();
    }
  }

  event() {
    this.initTab();
  }

  /**
   * タブ切り替え
   * 商品ページ: PC幅のみ。それ以外: PC/SP両方で有効
   */
  initTab() {
    const $wraps = $('.' + this.el);
    if (!$wraps.length) return;

    const PC_BREAKPOINT = 768;
    const mq = window.matchMedia(`(min-width: ${PC_BREAKPOINT}px)`);

    const applyPcTab = () => {
      $wraps.each((_, wrap) => {
        const $wrap = $(wrap);
        const $btns = $wrap.find('.tab-btn');
        const $contents = $wrap.find('.tab-content');

        $btns.off('click.tabPc').on('click.tabPc', function () {
          const index = $(this).index();
          $btns.removeClass('active');
          $(this).addClass('active');
          $contents.removeClass('active').hide();
          $contents.eq(index).addClass('active').show();
        });
        $contents.removeClass('active').hide();
        $contents.first().addClass('active').show();
        $btns.removeClass('active');
        $btns.first().addClass('active');
      });
    };

    const applyMobileTab = () => {
      $wraps.each((_, wrap) => {
        const $wrap = $(wrap);
        const $btns = $wrap.find('.tab-btn');
        const $contents = $wrap.find('.tab-content');

        $btns.off('click.tabPc');
        $contents.removeClass('active').show();
        $btns.removeClass('active');
      });
    };

    const handleResize = (e) => {
      if (e.matches) {
        applyPcTab();
      } else {
        if ($('.p-archive-product').length > 0) {
          applyMobileTab();
        } else {
          applyPcTab();
        }
      }
    };

    mq.addEventListener('change', handleResize);
    handleResize(mq);
  }
}